import * as React from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IconName, IconPrefix } from '@fortawesome/fontawesome'

const map = require('lodash/map')
const takeWhile = require('lodash/takeWhile')

export type ProgressBarStep = {
  iconSize?: number
  completed: boolean
  completedText?: string
  icon: [IconPrefix, IconName]
}

export interface ProgressBarProps {
  steps: ProgressBarStep[]
}

class ProgressBar extends React.Component<ProgressBarProps> {
  get completedPercentage() {
    const { steps } = this.props

    const completed = takeWhile(steps, 'completed')
    return completed.length / steps.length
  }

  render() {
    const { steps } = this.props

    const stepWidth = 100 / steps.length

    return (
      <div className="progressbar">
        {map(steps, (step, index) => (
          <div
            key={index}
            style={{ width: `${stepWidth}%`, maxWidth: `${stepWidth}%` }}
            className={classnames('progressstep', { 'progressstep--completed': step.completed })}
          >
            {step.completed
              ? (
                <React.Fragment>
                  <FontAwesomeIcon icon={['fas', 'check-circle']} style={{ fontSize: '28px' }} />
                  <span className="ml-2">{step.completedText}</span>
                </React.Fragment>
              )
              : <FontAwesomeIcon icon={step.icon} style={{ fontSize: `${step.iconSize || 23}px` }} />
            }
          </div>
        ))}

        <div className="progressindicator" style={{ width: `${this.completedPercentage*100}%` }} />
      </div>
    )
  }
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/common/ProgressBar.component.tsx